<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body" id="subscriptionFormBody">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="subscriptionForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="subscriptionType">Subscription Type</label>
              <ng-select
                [items]="subscriptionTypes"
                bindLabel="key"
                placeholder="Lessons"
                [searchable]="false"
                [clearable]="false"
                [closeOnSelect]="true"
                (change)="onSubscriptionTypeChange()"
                id="subscriptionType"
                class="filter"
                formControlName="subscriptionType"
                #selectedSubscriptionTypeSelect
              />
            </div>
          </div>
          <div class="form-row"
               [style.display]="subscriptionForm.controls.subscriptionType.value.value === subscriptionType.COURSE ? 'flex' : 'none'">
            <div class="col-md-6 mb-3">
              <label for="bundleId">Select Course <sup>*</sup></label>
              <ng-select
                [items]="courses"
                bindLabel="name"
                bindValue="id"
                placeholder="Course"
                [searchable]="false"
                [clearable]="false"
                [closeOnSelect]="true"
                formControlName="bundleId"
                id="bundleId"
                appendTo="body"
                class="filter"
              />
            </div>
          </div>
          <div class="form-row"
               [style.display]="subscriptionForm.controls.subscriptionType.value.value === subscriptionType.COURSE ||
                 subscriptionForm.controls.subscriptionType.value.value === subscriptionType.REGULAR ? 'flex' : 'none'"
          >
            <div class="col-md-6 mb-3">
              <label for="price">Price <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="price" id="price" placeholder="Price"
                     [readOnly]="!!subscriptionForm.controls.id.value">
            </div>
            <div class="col-md-6 mb-3"
                 *ngIf="subscriptionForm.controls.subscriptionType.value.value === subscriptionType.REGULAR
                   || subscriptionForm.controls.subscriptionType.value.value === subscriptionType.COURSE">
              <label for="lessonsCount">Lessons count <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="lessonsCount" id="lessonsCount"
                     placeholder="Lessons count">
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="name">Name Hebrew <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="nameHebrew" id="nameHebrew"
                     placeholder="Subscription Name Hebrew">
            </div>
            <div class="col-md-6 mb-3">
              <label for="name">Name <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="name" id="name"
                     placeholder="Subscription Name">
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="descriptionHebrew">Description Hebrew <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="descriptionHebrew" id="descriptionHebrew"
                     placeholder="Description Hebrew">
            </div>
            <div class="col-md-6 mb-3">
              <label for="description">Description <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="description" id="description"
                     placeholder="Description">
            </div>
          </div>
          <div class="form-row"
               formGroupName="createCampRequest"
               [style.display]="subscriptionForm.controls.subscriptionType.value.value === subscriptionType.EVENT ? 'flex' : 'none'">
            <div class="col-md-4 mb-3">
              <label for="maxStudents">Max Students <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="maxStudents" id="maxStudents"
                     placeholder="Max Students Time">
            </div>
            <div class="col-md-4 mb-3">
              <label for="minAge">Min Age <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="minAge" id="minAge"
                     placeholder="Min Age">
            </div>
            <div class="col-md-4 mb-3">
              <label for="maxAge">Max Age <sup>*</sup></label>
              <input type="text" class="form-control" formControlName="maxAge" id="maxAge"
                     placeholder="Max Age">
            </div>
          </div>
          <div formGroupName="createCampRequest"
               [style.display]="subscriptionForm.controls.subscriptionType.value.value === subscriptionType.EVENT ? 'block' : 'none'">
            <div formArrayName="periods">
              <div class="form-row">
                <div class="col-md-10 mb-3">
                  Periods <sup>*</sup>
                </div>
                <div class="col-md-2 mb-3" style="display: flex; justify-content: flex-end">
                  <button type="button" class="btn btn-primary" (click)="addPeriod()" [disabled]="!!subscriptionForm.controls.id.value">Add Period</button>
                </div>
              </div>
              <div *ngFor="let period of periods.controls; let i = index" [formGroupName]="i" class="form-row mb-3 p-2 border rounded">
                <div class="col-md-3 mb-3">
                  <label for="startDate-{{i}}">Start Date <sup>*</sup></label>
                  <input type="date" class="form-control" formControlName="periodStartDate" [id]="'startDate-' + i">
                </div>
                <div class="col-md-3 mb-3">
                  <label for="endDate-{{i}}">End Date <sup>*</sup></label>
                  <input type="date" class="form-control" formControlName="periodEndDate" [id]="'endDate-' + i">
                </div>
                <div class="col-md-3 mb-3">
                  <label for="startTime-{{i}}">Start Time <sup>*</sup></label>
                  <input type="time" class="form-control" formControlName="periodStartTime" [id]="'startTime-' + i">
                </div>
                <div class="col-md-3 mb-3">
                  <label for="endTime-{{i}}">End Time <sup>*</sup></label>
                  <input type="time" class="form-control" formControlName="periodEndTime" [id]="'endTime-' + i">
                </div>
                <div class="text-danger mt-1 mb-1 col-md-12" *ngIf="period.invalid && period.errors?.invalidDateRange">
                  End date & time must be after start date & time.
                </div>
                <div class="text-danger mt-1 mb-1 col-md-12" *ngIf="period.errors?.invalidTimeRange">
                  End time must be after start time.
                </div>
                <div class="col-12 text-end">
                  <button type="button" class="btn btn-danger btn-sm" (click)="removePeriod(i)" *ngIf="periods.length > 1">Remove</button>
                </div>
              </div>
            </div>
            <div formArrayName="prices" class="mb-3 p-2 border rounded"
                 [style.display]="subscriptionForm.controls.subscriptionType.value.value === subscriptionType.EVENT ? 'block' : 'none'">
              <div *ngFor="let option of prices.controls; let i = index" [formGroupName]="i" class="mb-2 d-flex align-items-center gap-2 col-12">
                <input type="checkbox" formControlName="selected" [id]="'option-' + i">
                <label [for]="'option-' + i" class="mb-0" style="min-width: 120px;">
                  {{ i + 1 }} {{ i + 1 === 1 ? 'period' : 'periods' }}
                </label>

                <input type="number" formControlName="amount" class="form-control" placeholder="Price"
                       style="max-width: 120px;" [readOnly]="!!subscriptionForm.controls.id.value">
              </div>
            </div>
          </div>


          <div class="col-md-3 mb-3">
            <div class="form-check form-check-inline enabled-checkbox">
              <input class="form-check-input" type="checkbox" formControlName="isOnline" id="isOnline">
              <label class="form-check-label" for="isOnline">Online</label>
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button *ngIf="subscriptionForm.controls.subscriptionType.value.value !== subscriptionType.EVENT || !subscription"
              type="button" class="btn btn-default add-edit-button" (click)="closeModal(subscriptionForm)">Save
            </button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{ errorMessage }}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
